<template>
  <span class="item-controls" v-if="(hover || show_dropdown) && isAuth" v-on-clickaway="clickAway" @click.prevent.stop="">
    <i title="Drag to reorder" class="ion ion-md-reorder handle" v-if="editable"></i>
    <div title="Options" class="dropdown item-menu" :class="{'show': show_dropdown}">
      <i @click.stop="show_dropdown = !show_dropdown" class="fa dropdown-icon-button" :class="{'fa-chevron-circle-down': !show_dropdown, 'fa-chevron-circle-up': show_dropdown}" data-toggle="dropdown">
      </i>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" >
        <a class="dropdown-item" href="#" v-if="editable" @click.prevent.stop="editItem"><i class="ion ion-md-create"></i> Edit</a>
        <a class="dropdown-item" href="#" @click.prevent.stop="copyListItem"><i class="ion ion-md-add"></i> Copy Item</a>
        <a class="dropdown-item" href="#" v-if="editable" @click.prevent.stop="deleteItem" style="color: red;"><i class="ion ion-md-trash"></i> Delete</a>
      </div>
    </div>
  </span>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'ItemMenu',
  mixins: [clickaway],
  props: {
    editable: Boolean,
    hover: Boolean,
    item: Object,
  },
  computed: {
    isAuth () {
      return this.$store.getters['users/isAuth']
    }
  },
  data () {
    return {
      show_dropdown: false,
    }
  },
  methods: {
    clickAway () {
      this.show_dropdown = false
    },
    editItem () {
      this.show_dropdown = false
      this.$emit('edit')
    },
    deleteItem () {
      this.show_dropdown = false
      this.$emit('delete')
    },
    copyListItem () {
      this.show_dropdown = false
      this.$store.dispatch('lists/showCopyItemModal', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-menu {
  display: inline-block;
  .dropdown-icon-button {
    cursor: pointer;
    font-size: 14px;
    vertical-align: text-bottom;
    line-height: 25px;
    color: rgba(255, 255, 255, 0.5);
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
}
.dropdown-container {
  padding: 20px;
  position: absolute;
  top: 0%;
  right: -20px !important;
  left: auto !important;
}
.dropdown-menu.dropdown-menu-right:before,
.dropdown-menu.dropdown-menu-right:after {
  left: auto;
  right: 2px;
}
.item-controls {
  border: 1px solid #356886;
  box-sizing: border-box;
  background: #202022;
  padding: 4px 8px;
  border-radius: 4px;
  position: absolute;
  right: 10px;
  display: flex;
  justify-content: space-around;
  max-width: 65px;
  i.ion, i.fa {
    cursor: pointer;
    &.handle {
      font-size: 25px;
      vertical-align: text-bottom;
      margin-right: 15px;
    }
  }
  i.ion.edit-control:hover {
    font-size: 18px;
    color: rgba(255, 255, 255, 1);
  }
}
@media screen and (max-width: 768px) {
  div.card div.card-body > ul.list-group > li.list-group-item > .list-item-content {
    .item-controls {
      position: absolute;
      right: 5px;
      align-items: center;
      height: 85%;
      max-height: 60px;
      width: 125px;
      padding-left: 10px;
      i.ion, i.fa {
        &.handle {
          font-size: 30px;
          margin-right: 5px;
        }
      }
      .item-menu {
        .dropdown-icon-button {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
